import { SysIAnalitos } from "./types.analitos";
import { SysIAccionesMonitoreo } from "./types.config";
import { SysI_Estudios } from "./types.estudios";
import { Order } from "./types.orders";
import { User } from "./types.user";

export interface SysI_MonitoreoOrdenes {
    Mto_Id: number;
    Mto_Us_Id: number;
    Mto_Ord_Id: number;
    Mto_Est_Id: number;
    Mto_Es_Id?: number;
    Mto_An_Id?: number;
    Mto_Acm_Id: number;
    Mto_Fecha: Date;
    Mto_Observacion?: string;
    Usuario: User;
    Orden: Order;
    Estudio: SysI_Estudios;
    Analito: SysIAnalitos;
}

export enum EMonitoreoServiciosMasivos {
    Email = 1,
    WhatsApp = 2,
    RemisionExterna = 3,
}

export interface SysI_MonitoreoServiciosMasivos {
    Mtsm_Id: number;
    Mtsm_Ord_Id: number;
    Mtsm_Es_Id?: number;
    Mtsm_An_Id?: number;
    Mtsm_Destinatario?: string;
    Mtsm_Tipo: EMonitoreoServiciosMasivos;
    Mtsm_Fecha: Date;
    Mtsm_Mensaje?: string;
    Mtsm_Estado: boolean;
    Orden?: Order;
    Estudio?: SysI_Estudios;
    Analito?: SysIAnalitos;
}